import React from 'react';
import ReactDOM from 'react-dom/client';

import TravelSearch from './TravelSearch';

const root = ReactDOM.createRoot(document.getElementById('travel_search'));

root.render(<TravelSearch />);
